<template>
    <app-content class="h-panel">
        <div class="h-panel-bar"><span class="h-panel-title">员工信息</span></div>
        <div class="margin-top margin-left filter-bar">
            <span>部门：</span>
            <Select v-model="filter.department" :datas="departmentOptions" keyName="key" titleName="title" :deletable="true" style="width:130px" @change="loadList"></Select>
            <span class="label">员工状态：</span>
            <Select v-model="filter.employeeStatus" :datas="statusOptions" keyName="key" titleName="title" :deletable="true" style="width:120px" @change="loadList"></Select>
            <span class="label">员工类型：</span>
            <Select v-model="filter.employeeType" :datas="typeOptions" keyName="key" titleName="title" :deletable="true" style="width:120px" @change="loadList"></Select>
            <input type="text" v-model="filter.keyword" placeholder="姓名 | 手机 | 身份证" class="input-small" @keyup.enter="loadList">
            <Button size="s" color="primary" @click="loadList">检索</Button>
            <span class="flex-spacer"></span>
            <Button color="primary" size="s" @click="add">新增</Button>
            <Button size="s" @click="notOpen('批量操作')">批量操作</Button>
            <Button size="s" @click="showImport=true">导入</Button>
            <Button size="s" @click="exportData">导出</Button>
        </div>
        <div class="h-panel-body">
            <div class="table-wrap">
                <table class="grid">
                    <thead>
                    <tr>
                        <th>编号</th>
                        <th>姓名</th>
                        <th>证件类型</th>
                        <th>证件号码</th>
                        <th>性别</th>
                        <th>出生日期</th>
                        <th>部门</th>
                        <th>手机号码</th>
                        <th>邮箱</th>
                        <th>计提工资科目</th>
                        <th>社保信息</th>
                        <th>公积金信息</th>
                        <th>员工状态</th>
                        <th>人员状态</th>
                        <th>报送状态</th>
                        <th>身份验证状态</th>
                        <th>任职受雇从业日期</th>
                        <th>离职日期</th>
                        <th>是否扣除减除费用</th>
                        <th>职务</th>
                        <th>学历</th>
                        <th>开户银行</th>
                        <th>银行账号</th>
                        <th>开户行省份</th>
                        <th>银行卡状态</th>
                        <th>经常居住地（省）</th>
                        <th>经常居住地（市）</th>
                        <th>经常居住地（区县）</th>
                        <th>经常居住地（街道）</th>
                        <th>经常居住地（详细地址）</th>
                        <th>户籍所在地（省）</th>
                        <th>户籍所在地（市）</th>
                        <th>户籍所在地（区县）</th>
                        <th>户籍所在地（街道）</th>
                        <th>户籍所在地（详细地址）</th>
                        <th>是否残疾</th>
                        <th>是否烈属</th>
                        <th>是否孤老</th>
                        <th>任职受雇从业类型</th>
                        <th>入职年度就业情形</th>
                        <th>其他情况说明</th>
                        <th>国籍(地区)</th>
                        <th>纳税人识别号</th>
                        <th>个人投资额</th>
                        <th>个人投资比例(%)</th>
                        <th>备注</th>
                        <th>残疾证件类型</th>
                        <th>残疾证号</th>
                        <th>烈属证号</th>
                        <th>联系地址（省）</th>
                        <th>联系地址（市）</th>
                        <th>联系地址（区县）</th>
                        <th>联系地址（街道）</th>
                        <th>联系地址（详细地址）</th>
                        <th>个税更新时间</th>
                        <th style="width:90px">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in datas" :key="item.id">
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.idType}}</td>
                        <td>{{item.idNumber}}</td>
                        <td>{{item.gender}}</td>
                        <td>{{fmtDate(item.birthDate)}}</td>
                        <td>{{item.department}}</td>
                        <td>{{item.phone}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.salarySubject}}</td>
                        <td>{{item.socialSecurityInfo}}</td>
                        <td>{{item.fundInfo}}</td>
                        <td>{{item.employeeStatus}}</td>
                        <td>{{item.personStatus}}</td>
                        <td>{{item.reportStatus}}</td>
                        <td>{{item.identityStatus}}</td>
                        <td>{{fmtDate(item.employDate)}}</td>
                        <td>{{fmtDate(item.leaveDate)}}</td>
                        <td>{{item.deductExemption === 1 ? '是' : '否'}}</td>
                        <td>{{item.position}}</td>
                        <td>{{item.education}}</td>
                        <td>{{item.bankName}}</td>
                        <td>{{item.bankAccount}}</td>
                        <td>{{item.bankProvince}}</td>
                        <td>{{item.bankCardStatus}}</td>
                        <td>{{item.residenceProvince}}</td>
                        <td>{{item.residenceCity}}</td>
                        <td>{{item.residenceDistrict}}</td>
                        <td>{{item.residenceStreet}}</td>
                        <td>{{item.residenceDetail}}</td>
                        <td>{{item.householdProvince}}</td>
                        <td>{{item.householdCity}}</td>
                        <td>{{item.householdDistrict}}</td>
                        <td>{{item.householdStreet}}</td>
                        <td>{{item.householdDetail}}</td>
                        <td>{{item.disabled === 1 ? '是' : '否'}}</td>
                        <td>{{item.martyrs === 1 ? '是' : '否'}}</td>
                        <td>{{item.aloneElder === 1 ? '是' : '否'}}</td>
                        <td>{{item.employType}}</td>
                        <td>{{item.joinYearSituation}}</td>
                        <td>{{item.otherDesc}}</td>
                        <td>{{item.nationality}}</td>
                        <td>{{item.taxpayerId}}</td>
                        <td class="num">{{item.personalInvestAmount|numFormat}}</td>
                        <td class="num">{{item.personalInvestRatio|numFormat}}</td>
                        <td>{{item.remark}}</td>
                        <td>{{item.disabledCertType}}</td>
                        <td>{{item.disabledCertNo}}</td>
                        <td>{{item.martyrsCertNo}}</td>
                        <td>{{item.contactProvince}}</td>
                        <td>{{item.contactCity}}</td>
                        <td>{{item.contactDistrict}}</td>
                        <td>{{item.contactStreet}}</td>
                        <td>{{item.contactDetail}}</td>
                        <td>{{fmtDate(item.taxUpdateTime)}}</td>
                        <td class="actions"><span @click="edit(item)">编辑</span><span @click="remove(item)">删除</span></td>
                    </tr>
                    <tr v-if="!datas.length"><td :colspan="56" class="text-center padding">暂无数据</td></tr>
                    </tbody>
                </table>
            </div>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id?'编辑员工信息':'新增员工信息'}}</div>
            <div class="form-scroll">
                <div class="sec-title">基本信息</div>
                <div class="form-grid3">
                    <div class="f-item"><label class="req">编码</label><input type="text" v-model="form.code"></div>
                    <div class="f-item"><label class="req">名称</label><input type="text" v-model="form.name"></div>
                    <div class="f-item"><label>性别</label><Select v-model="form.gender" :datas="opt.genders" :deletable="true"></Select></div>
                    <div class="f-item"><label>部门</label><input type="text" v-model="form.department"></div>
                    <div class="f-item"><label>职务</label><input type="text" v-model="form.position"></div>
                    <div class="f-item"><label>岗位</label><input type="text" v-model="form.jobPost"></div>
                    <div class="f-item"><label>手机</label><input type="text" v-model="form.phone"></div>
                    <div class="f-item"><label>身份证号</label><input type="text" v-model="form.idNumber"></div>
                    <div class="f-item"><label>邮箱</label><input type="text" v-model="form.email"></div>
                    <div class="f-item"><label>出生日期</label><DatePicker v-model="form.birthDate" type="date" format="yyyy-MM-dd"></DatePicker></div>
                    <div class="f-item"><label>入职日期</label><DatePicker v-model="form.employDate" type="date" format="yyyy-MM-dd"></DatePicker></div>
                    <div class="f-item"><label>离职日期</label><DatePicker v-model="form.leaveDate" type="date" format="yyyy-MM-dd"></DatePicker></div>
                    <div class="f-item"><label>银行名称</label><input type="text" v-model="form.bankName"></div>
                    <div class="f-item"><label>银行账号</label><input type="text" v-model="form.bankAccount"></div>
                    <div class="f-item"><label>学历</label><Select v-model="form.education" :datas="opt.education" :deletable="true"></Select></div>
                    <div class="f-item"><label>在职状态</label><Select v-model="form.employeeStatus" :datas="[{key:'在职',title:'在职'},{key:'离职',title:'离职'}]" :deletable="true"></Select></div>
                    <div class="f-item"><label>计提科目</label><input type="text" v-model="form.salarySubject"></div>
                    <div class="f-item full"><label>备注</label><input type="text" v-model="form.remark"></div>
                </div>

                <div class="sec-title">员工扩展</div>
                <div class="form-grid3">
                    <div class="f-item"><label>证件类型</label><Select v-model="form.idType" :datas="opt.idTypes" :deletable="true"></Select></div>
                    <div class="f-item"><label>国籍</label><input type="text" v-model="form.nationality"></div>
                    <div class="f-item"><label>人员状态</label><input type="text" v-model="form.personStatus"></div>
                    <div class="f-item"><label>是否扣除减除费用</label><Select v-model="form.deductExemption" :datas="[{key:1,title:'是'},{key:0,title:'否'}]" keyName="key" titleName="title"></Select></div>
                    <div class="f-item"><label>开户行省份</label><input type="text" v-model="form.bankProvince"></div>
                    <div class="f-item"><label>银行卡状态</label><input type="text" v-model="form.bankCardStatus"></div>
                    <div class="f-item"><label>任职受雇从业类型</label><Select v-model="form.employType" :datas="opt.employTypes" :deletable="true"></Select></div>
                    <div class="f-item"><label>入职年度就业情形</label><input type="text" v-model="form.joinYearSituation"></div>
                    <div class="f-item"><label>纳税人识别号</label><input type="text" v-model="form.taxpayerId"></div>
                    <div class="f-item"><label>个人投资额</label><NumberInput v-model="form.personalInvestAmount" :precision="2"></NumberInput></div>
                    <div class="f-item"><label>个人投资比例(%)</label><NumberInput v-model="form.personalInvestRatio" :precision="2"></NumberInput></div>
                    <div class="f-item"><label>其他情况说明</label><input type="text" v-model="form.otherDesc"></div>
                </div>
                <div class="form-grid5">
                    <div class="f-item"><label>经常居住地(省)</label><input type="text" v-model="form.residenceProvince"></div>
                    <div class="f-item"><label>经常居住地(市)</label><input type="text" v-model="form.residenceCity"></div>
                    <div class="f-item"><label>经常居住地(区县)</label><input type="text" v-model="form.residenceDistrict"></div>
                    <div class="f-item"><label>经常居住地(街道)</label><input type="text" v-model="form.residenceStreet"></div>
                    <div class="f-item"><label>经常居住地(详细)</label><input type="text" v-model="form.residenceDetail"></div>
                    <div class="f-item"><label>户籍所在地(省)</label><input type="text" v-model="form.householdProvince"></div>
                    <div class="f-item"><label>户籍所在地(市)</label><input type="text" v-model="form.householdCity"></div>
                    <div class="f-item"><label>户籍所在地(区县)</label><input type="text" v-model="form.householdDistrict"></div>
                    <div class="f-item"><label>户籍所在地(街道)</label><input type="text" v-model="form.householdStreet"></div>
                    <div class="f-item"><label>户籍所在地(详细)</label><input type="text" v-model="form.householdDetail"></div>
                    <div class="f-item"><label>联系地址(省)</label><input type="text" v-model="form.contactProvince"></div>
                    <div class="f-item"><label>联系地址(市)</label><input type="text" v-model="form.contactCity"></div>
                    <div class="f-item"><label>联系地址(区县)</label><input type="text" v-model="form.contactDistrict"></div>
                    <div class="f-item"><label>联系地址(街道)</label><input type="text" v-model="form.contactStreet"></div>
                    <div class="f-item"><label>联系地址(详细)</label><input type="text" v-model="form.contactDetail"></div>
                </div>
                <div class="form-grid3">
                    <div class="f-item"><label>是否存在以下情形</label>
                        <div class="checkbox-row">
                            <Checkbox v-model="form.disabled" :trueValue="1" :falseValue="0">残疾</Checkbox>
                            <Checkbox v-model="form.martyrs" :trueValue="1" :falseValue="0">烈属</Checkbox>
                            <Checkbox v-model="form.aloneElder" :trueValue="1" :falseValue="0">孤老</Checkbox>
                        </div>
                    </div>
                    <div class="f-item"><label>残疾证件类型</label><input type="text" v-model="form.disabledCertType"></div>
                    <div class="f-item"><label>残疾证号</label><input type="text" v-model="form.disabledCertNo"></div>
                    <div class="f-item"><label>烈属证号</label><input type="text" v-model="form.martyrsCertNo"></div>
                </div>

                <div class="sec-title">扣除款项</div>
                <div class="f-item inline"><label>是否购买社保：</label>
                    <Radio v-model="form.buySocial" :value="1">是</Radio>
                    <Radio v-model="form.buySocial" :value="0">否</Radio>
                </div>
                <table class="grid mini" v-if="form.buySocial">
                    <thead><tr><th>项目</th><th>缴存基数</th><th class="num">公司缴存比例(%)</th><th class="num">公司缴存金额</th><th class="num">个人缴存比例(%)</th><th class="num">个人缴存金额</th></tr></thead>
                    <tbody>
                    <tr v-for="(r,i) in form.socialRows" :key="i">
                        <td><input type="text" v-model="r.project" class="tbl-inp"></td>
                        <td><NumberInput v-model="r.baseAmount" :precision="2" class="tbl-inp"></NumberInput></td>
                        <td><NumberInput v-model="r.companyRatio" :precision="3" class="tbl-inp" @change="calcRow(r)"></NumberInput></td>
                        <td class="num">{{r.companyAmount|numFormat}}</td>
                        <td><NumberInput v-model="r.personalRatio" :precision="3" class="tbl-inp" @change="calcRow(r)"></NumberInput></td>
                        <td class="num">{{r.personalAmount|numFormat}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="drawer-footer">
                <Button @click="showForm=false">取消</Button>
                <Button color="primary" @click="save" :loading="loading">保存</Button>
            </div>
        </Modal>

        <import-modal v-model="showImport" title="员工信息导入" templateUrl="/api/salary-employee/template"
                      :import-fn="importEmployee" @success="loadList"/>
    </app-content>
</template>

<script>
import ImportModal from '../../components/common/ImportModal';
import { exportXls } from '../../js/common/export';

export default {
    name: 'SalaryEmployee',
    components: { ImportModal },
    data() {
        return {
            datas: [],
            filter: { department: null, employeeStatus: null, employeeType: null, keyword: '' },
            departmentOptions: [{ key: '', title: '全部部门' }],
            statusOptions: [{ key: 1, title: '在职' }, { key: 0, title: '离职' }],
            typeOptions: [{ key: '', title: '全部类型' }],
            opt: { idTypes: [], genders: [], employTypes: [], education: [] },
            showForm: false, loading: false, showImport: false,
            form: this.emptyForm()
        };
    },
    methods: {
        emptyForm() {
            return {
                id: null, code: '', name: '', gender: '', department: '', position: '', jobPost: '', phone: '', idNumber: '', email: '',
                birthDate: null, employDate: null, leaveDate: null, bankName: '', bankAccount: '', education: '', employeeStatus: '在职', salarySubject: '', remark: '',
                idType: '居民身份证', nationality: '中国', personStatus: '', deductExemption: 1, bankProvince: '', bankCardStatus: '',
                employType: '', joinYearSituation: '', taxpayerId: '', personalInvestAmount: 0, personalInvestRatio: 0, otherDesc: '',
                disabled: 0, martyrs: 0, aloneElder: 0, disabledCertType: '', disabledCertNo: '', martyrsCertNo: '',
                residenceProvince: '', residenceCity: '', residenceDistrict: '', residenceStreet: '', residenceDetail: '',
                householdProvince: '', householdCity: '', householdDistrict: '', householdStreet: '', householdDetail: '',
                contactProvince: '', contactCity: '', contactDistrict: '', contactStreet: '', contactDetail: '',
                buySocial: 0, socialRows: [
                    { project: '养老保险', baseAmount: 0, companyRatio: 0, companyAmount: 0, personalRatio: 0, personalAmount: 0 },
                    { project: '医疗保险', baseAmount: 0, companyRatio: 0, companyAmount: 0, personalRatio: 0, personalAmount: 0 },
                    { project: '工伤保险', baseAmount: 0, companyRatio: 0, companyAmount: 0, personalRatio: 0, personalAmount: 0 },
                    { project: '失业保险', baseAmount: 0, companyRatio: 0, companyAmount: 0, personalRatio: 0, personalAmount: 0 },
                    { project: '公积金', baseAmount: 0, companyRatio: 0, companyAmount: 0, personalRatio: 0, personalAmount: 0 }
                ]
            };
        },
        fmtDate(d) { if (!d) return ''; if (typeof d === 'string') return d.slice(0, 10); return d.toISOString ? d.toISOString().slice(0, 10) : d; },
        loadList() {
            const p = Object.assign({}, this.filter);
            if (p.department === '') p.department = null;
            if (p.employeeType === '') p.employeeType = null;
            this.$api.salary.employee.list(p).then(({ data }) => { this.datas = data || []; });
        },
        add() { this.form = this.emptyForm(); this.showForm = true; },
        edit(item) {
            this.$api.salary.employee.load(item.id).then(({ data }) => {
                const f = Object.assign(this.emptyForm(), data || {});
                if (!f.socialRows || !f.socialRows.length) f.socialRows = this.emptyForm().socialRows;
                this.form = f;
                this.showForm = true;
            });
        },
        remove(item) {
            this.$Confirm('确认删除该员工?').then(() => {
                this.$api.salary.employee.delete(item.id).then(() => { this.loadList(); this.$Message.success('已删除'); });
            });
        },
        calcRow(r) {
            r.companyAmount = Number((r.baseAmount || 0) * (r.companyRatio || 0) / 100).toFixed(2) * 1;
            r.personalAmount = Number((r.baseAmount || 0) * (r.personalRatio || 0) / 100).toFixed(2) * 1;
        },
        save() {
            if (!this.form.code || !this.form.name) { this.$Message.error('请填写编码和名称'); return; }
            const p = Object.assign({}, this.form);
            p.socialSecurityInfo = p.buySocial ? p.socialRows.map(r => `${r.project}:${r.companyAmount}/${r.personalAmount}`).join(';') : '';
            const fund = p.socialRows.find(r => r.project === '公积金');
            p.fundInfo = fund ? `${fund.companyAmount}/${fund.personalAmount}` : '';
            this.loading = true;
            this.$api.salary.employee[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false; this.showForm = false; this.loadList(); this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        },
        importEmployee(fd) {
            return this.$api.salary.employee.importData(fd);
        },
        exportData() {
            this.$api.salary.employee.list({}).then(({ data }) => {
                const list = data || [];
                if (!list.length) { this.$Message('暂无数据可导出'); return; }
                const head = ['编号', '姓名', '证件类型', '证件号码', '性别', '出生日期', '部门', '职务', '手机号码', '邮箱', '学历', '入职日期', '离职日期', '计提工资科目', '员工状态', '备注'];
                const rows = list.map(it => [it.code, it.name, it.idType, it.idNumber, it.gender, this.fmtDate(it.birthDate), it.department, it.position, it.phone, it.email, it.education, this.fmtDate(it.employDate), this.fmtDate(it.leaveDate), it.salarySubject, it.employeeStatus, it.remark]);
                exportXls({ name: '员工信息', sheets: [{ name: '员工信息', head, rows, widths: [90, 100, 130, 180, 60, 110, 100, 100, 120, 160, 80, 110, 110, 140, 80, 160], types: head.map(() => 's') }] });
            });
        },
        notOpen(n) { this.$Message.info(`${n}功能暂未开放`); }
    },
    mounted() {
        this.loadList();
        this.$api.salary.employee.options().then(({ data }) => { this.opt = Object.assign(this.opt, data || {}); });
    }
};
</script>

<style scoped lang="less">
.filter-bar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    .label { margin-left: 6px; }
    .flex-spacer { flex: 1; }
    .input-small { width: 160px; height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 8px; }
}
.table-wrap { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; margin-top: 10px;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; height: 35px; }
    .num { text-align: right; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
}
.grid.mini { width: 100%; margin-top: 6px;
    th, td { height: 30px; padding: 0 4px; }
    .tbl-inp { width: 100%; border: none; background: transparent; height: 26px; }
}
.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
.form-scroll { padding: 10px 16px 70px; max-height: calc(100vh - 160px); overflow-y: auto; }
.sec-title { font-weight: bold; font-size: 14px; margin: 16px 0 10px; padding-left: 8px; border-left: 3px solid #3b91ff; }
.form-grid3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px 16px; margin-bottom: 10px;
    .f-item { display: flex; align-items: center;
        label { width: 110px; flex-shrink: 0; text-align: right; margin-right: 8px; font-size: 12px; }
        label.req::before { content: '*'; color: #e23c3c; margin-right: 2px; }
        input, .h-select, .h-numberinput, .h-datepicker { flex: 1; min-width: 0; }
        input { height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 6px; }
    }
    .f-item.full { grid-column: span 3; }
}
.form-grid5 { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px 10px; margin-bottom: 10px;
    .f-item { display: flex; align-items: center;
        label { width: 90px; flex-shrink: 0; text-align: right; margin-right: 6px; font-size: 12px; }
        input { flex: 1; height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 6px; }
    }
}
.f-item.inline { display: flex; align-items: center; margin: 8px 0;
    label { margin-right: 8px; }
}
.checkbox-row { display: flex; gap: 16px; }
.drawer-footer { position: absolute; bottom: 0; left: 0; right: 0; padding: 12px 16px; background: #fff; border-top: 1px solid #e8e8e8; text-align: center; }
</style>
